import { MaxProjectionYear, EntityTypes } from "../helpers/constant";
import CompareGraph from "../models/compareGraph";
export default {
  data() {
    return {
      projectionYear: {
        Value: 0,
        Maxvalue: MaxProjectionYear,
        IsError: false,
        ErrorText: [],
      },
      projectionDetails: [],
      iceApiResponse: {},
      compareGraphOwner: {},
      compareGraphOwners: [],
      mainHeading: "Table Comparison",
      selectedComponent: "chart-line-group",
      selectedtabId: "balanceGraph",
      startingYear: 0,
      chartData: [],
      rootWidth: 0,
      headersdata: [],
      rowsdata: {},
      tooltipHeader: [],
      chartProperties: {},
      tooltipData: [],
      tooltipDataProp: [],
      xAxisArray: [],
      xAxisMinValue: 0,
      lineAxisArray: [],
      projectionResult: {},
      compareOptionModel: {},
      chartTabContent: [
        {
          text: "Balance",
          id: "balanceGraph",
          active: true,
        },
        {
          text: "Transaction",
          id: "contributionWithdrawalGraph",
          active: false,
        },
        {
          text: "Return",
          id: "ReturnFeesGraph",
          active: false,
        },
      ],
      toolTipPropMapping: {
        balanceGraph: [{ id: "Balance", prop: "closingBalance" }],
        contributionWithdrawalGraph: [
          { id: "Balance", prop: "closingBalance", type: "contribution" },
        ],
        ReturnFeesGraph: [{ id: "Balance", prop: "closingBalance" }],
      },
      barColors: ["#005ba1", "#a50032", "#f5c400", "#00af41", "#00a8e1"],
      pageHeadingInfo: {
        heading: "Compare different investment instances",
        subHeading:
          "You can use the information to decide on strategies for a desired outcome",
      },
      investmentInstance: [],
      compareGraphProp: "",
      compareGraphOption: [],
      contentInfo: {},
      grouprow: [],
    };
  },
  async mounted() {
    this.setCompareOption();
  },
  methods: {
    setCompareOption() {
      this.compareOptionModel = {
        balanceGraph: [
          {
            id: "closingBalance",
            name: "",
            toolTipPro: [
              { id: "closingBalance", name: "Balance", isCurrencyType: true },
              {
                name: "Income (Cumulative)",
                id: "incomeReturnCumulative",
                isCurrencyType: true,
              },
              {
                name: "Growth (Cumulative)",
                id: "growthReturnCumulative",
                isCurrencyType: true,
              },
              {
                name: "Income & Growth (Cumulative)",
                id: "incomeGrowthReturnCumulative",
                isCurrencyType: true,
              },
              {
                id: "graphTitle",
                name: "graphTitle",
                isCurrencyType: true,
                ishide: true,
              },
            ],
          },
        ],

        contributionWithdrawalGraph: [
          {
            id: "contributionsAll",
            name: "Contributions",
            toolTipPro: [
              {
                id: "contributionsAll",
                name: "Contributions",
                isCurrencyType: true,
              },
              {
                id: "contributionsAllCumulative",
                name: "Contributions (Cumulative)",
                isCurrencyType: true,
              },
            ],
          },
          {
            id: "withdrawalsAll",
            name: "Withdrawals",
            toolTipPro: [
              {
                id: "withdrawalsAll",
                name: "Withdrawals",
                isCurrencyType: true,
              },
              {
                id: "withdrawalsAllCumulative",
                name: "Withdrawals (Cumulative)",
                isCurrencyType: true,
              },
              {
                id: "graphTitle",
                name: "graphTitle",
                isCurrencyType: true,
                ishide: true,
              },
            ],
          },
        ],

        ReturnFeesGraph: [
          {
            id: "incomeGrowthFees",
            name: "Income & Growth (Ex Fees) ",
            toolTipPro: [
              {
                id: "incomeGrowthFees",
                name: "Income & Growth (Ex Fees)",
                isCurrencyType: true,
              },

              {
                name: "Income",
                id: "incomeReturn",
                isCurrencyType: true,
              },
              {
                name: "Growth",
                id: "growthReturn",
                isCurrencyType: true,
              },
              {
                name: "Income & Growth (Ex Fees) (Cumulative)",
                id: "incomeGrowthReturnCumulative",
                isCurrencyType: true,
              },
              {
                name: "Income (Cumulative)",
                id: "incomeReturnCumulative",
                isCurrencyType: true,
              },
              {
                name: "Growth (Cumulative)",
                id: "growthReturnCumulative",
                isCurrencyType: true,
              },
              {
                id: "graphTitle",
                name: "graphTitle",
                isCurrencyType: true,
                ishide: true,
              },
            ],
          },
          {
            id: "incomeGrowthNetFees",
            name: "Income & Growth (Net of Fees)",
            toolTipPro: [
              {
                id: "incomeGrowthNetFees",
                name: "Income & Growth (Net)",
                isCurrencyType: true,
              },
              {
                name: "Income",
                id: "incomeReturn",
                isCurrencyType: true,
              },
              {
                name: "Growth",
                id: "growthReturn",
                isCurrencyType: true,
              },
              {
                name: "Fees",
                id: "fees",
                isCurrencyType: true,
              },
              {
                id: "graphTitle",
                name: "graphTitle",
                isCurrencyType: true,
                ishide: true,
              },
            ],
          },
          {
            id: "incomeReturn",
            name: "Income",
            toolTipPro: [
              {
                id: "incomeReturn",
                name: "Income",
                isCurrencyType: true,
              },
              {
                name: "Income (Cumulative)",
                id: "incomeReturnCumulative",
                isCurrencyType: true,
              },
              {
                id: "graphTitle",
                name: "graphTitle",
                isCurrencyType: true,
                ishide: true,
              },
            ],
          },
          {
            id: "growthReturn",
            name: "Growth",
            toolTipPro: [
              {
                id: "growthReturn",
                name: "Growth",
                isCurrencyType: true,
              },
              {
                name: "Growth (Cumulative)",
                id: "growthReturnCumulative",
                isCurrencyType: true,
              },
              {
                id: "graphTitle",
                name: "graphTitle",
                isCurrencyType: true,
                ishide: true,
              },
            ],
          },
          {
            id: "fees",
            name: "Fees",
            toolTipPro: [
              { id: "fees", name: "Total Fees", isCurrencyType: true },
              {
                id: "platformFees",
                name: "Platform Fees",
                isCurrencyType: true,
              },
              { id: "adviceFees", name: "Advice Fees", isCurrencyType: true },
              { id: "otherFees", name: "Other Fees", isCurrencyType: true },
              {
                id: "graphTitle",
                name: "graphTitle",
                isCurrencyType: true,
                ishide: true,
              },
            ],
          },
        ],
      };
    },
    fillCompareSuperOwnerTypeDetails(clientDetails) {
      let ownerEntityType = [];
      for (let i = 0; i < clientDetails.length; i++) {
        if (
          clientDetails[i].entityType == EntityTypes.client ||
          clientDetails[i].entityType == EntityTypes.partner ||
          clientDetails[i].entityType == EntityTypes.both
        ) {
          let clientObj = {
            entityType: clientDetails[i].entityType,
            value: clientDetails[i].clientId,
            text: clientDetails[i].clientName.replace(/(^MRS|MR|MISS)/gi, ""),
          };
          if (clientDetails[i].entityType == EntityTypes.both) {
            this.compareGraphOwner = clientObj;
          } else if (
            !this.compareGraphOwner.id &&
            clientDetails[i].entityType == EntityTypes.client
          ) {
            this.compareGraphOwner = clientObj;
          }
          ownerEntityType.push(clientObj);
        }
      }
      return ownerEntityType;
    },

    onChangeChartTab(tabId) {
      this.chartData = [];
      this.selectedTabComponent = tabId;
      this.selectedtabId = tabId;
      this.compareGraphOption = this.getcompareGraphOption(
        this.selectedTabComponent
      );
      this.compareGraphProp = this.compareGraphOption[0].name;
    },
    refreshChart(selectedOption, totalSelectedSuper) {
      let graphModel = {};
      let width = 0;
      let isIncludeStartingPoint = 0;
      if (this.selectedTabComponent == "balanceGraph") {
        this.compareGraphOption = [];
        this.compareGraphProp = "Balance";
        this.selectedComponent = "chart-line-group";
        graphModel = CompareGraph.initializeLineGraphWithDefaultValue(
          this.startingYear,
          this.startingYear + this.projectionYear.Value
        );
        width = this.rootWidth;
        isIncludeStartingPoint = true;
      } else {
        this.selectedComponent = "chart-bar-group";
        graphModel = CompareGraph.initializeBarGraphWithDefaultValue(
          this.startingYear,
          this.startingYear + this.projectionYear.Value
        );
        width = (totalSelectedSuper + 1) * 18 * this.projectionYear.Value;
        if (width < this.rootWidth) {
          width = this.rootWidth;
        }
        isIncludeStartingPoint = false;
      }
      this.refreshChartData(
        selectedOption,
        graphModel,
        width,
        isIncludeStartingPoint
      );
    },

    resetChartModel(graphModel, graphPros, width, toolTipBoxWidth) {
      this.chartData = graphModel.data;
      this.tooltipData = graphModel.toolTipData;
      this.tooltipHeader = graphPros.charttooltipHeader;
      this.chartProperties = CompareGraph.getChartProperties(
        graphModel.maxYAxis,
        graphPros.chartLegendColors,
        graphPros.chartLegends,
        width,
        graphModel.domainX,
        toolTipBoxWidth,
        this.compareGraphProp,
        graphModel.minYAxis
      );
    },

    getcompareGraphOption(tabId) {
      return this.compareOptionModel[tabId];
    },

    getScreenWidth() {
      this.rootWidth =
        this.parentContainerWidth -
        (this.chartProperties.axisRightWidth +
          this.chartProperties.axisRightWidth);
    },
    changeEngagementCompareProjectionYear(value) {
      this.projectionYear.Value = value;

      this.validationsEngagementCompareProjectionYear();
    },
    validationsEngagementCompareProjectionYear() {
      if (
        this.projectionYear.Value <= 0 ||
        this.projectionYear.Value > MaxProjectionYear
      ) {
        this.projectionYear.IsError = true;
        this.projectionYear.ErrorText = ["Value should be greater than Zero."];

        return false;
      } else {
        this.projectionYear.IsError = false;

        return true;
      }
    },
  },
};
